// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import Tw__AccordionController from "./tw/accordion_controller"
application.register("tw--accordion", Tw__AccordionController)

import Tw__AutocompleteController from "./tw/autocomplete_controller"
application.register("tw--autocomplete", Tw__AutocompleteController)

import Tw__DismissibleController from "./tw/dismissible_controller"
application.register("tw--dismissible", Tw__DismissibleController)

import Tw__DropdownController from "./tw/dropdown_controller"
application.register("tw--dropdown", Tw__DropdownController)

import Tw__ExpirableController from "./tw/expirable_controller"
application.register("tw--expirable", Tw__ExpirableController)

import Tw__FilesUploadController from "./tw/files_upload_controller"
application.register("tw--files-upload", Tw__FilesUploadController)

import Tw__ModalController from "./tw/modal_controller"
application.register("tw--modal", Tw__ModalController)

import Tw__SlideoverController from "./tw/slideover_controller"
application.register("tw--slideover", Tw__SlideoverController)
